import type {
  ApiEstimationStage,
  ApiSortEstimationsPerProjectBy,
  ApiSortNotificationsBy,
  ApiSortUsersBy,
} from '@/api/schema/data-contracts';

export type MutationProps = {
  onError: (error: unknown) => void;
  onSuccess: () => void;
};

export type EstimationsListParams = {
  onlyCurrent?: boolean;
  projectId?: string;
  projectTypeId?: string;
  estimationStage?: ApiEstimationStage;
  planningResponsibleId?: string;
  fulltextSearch?: string;
  pageNumber?: number;
  pageSize?: number;
  sortBy?: ApiSortEstimationsPerProjectBy;
  sortAscending?: boolean;
  onlyMine?: boolean;
};

export type UsersListParams = {
  pageNumber?: number;
  pageSize?: number;
  sortBy?: ApiSortUsersBy;
  sortAscending?: boolean;
  fulltextSearch?: string;
};

export type MethodologyListParams = {
  methodologyIds?: string[];
  /**
   * If true return only methodologies, where IsCurrent is true. If false return all methodologies regardless of IsCurrent is true or false.
   * @default true
   */
  onlyCurrent?: boolean;
};
export type EstimationModelListParams = {
  /** @format uuid */
  projectTypeId?: string;
  isPublished?: boolean;
  isLatestPublishedVersion?: boolean;
  /** EWM-1036: archived models are excluded unless this is true. */
  includeArchived?: boolean;
};

export type NotificationListParams = {
  /**
   * Starting from 1
   * @format int32
   * @min 1
   * @max 2147483647
   */
  pageNumber?: number;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  pageSize?: number;
  sortBy?: ApiSortNotificationsBy;
  sortAscending?: boolean;
};

export const GetCurrentUserLatestEstimationQueryKey = ['user', 'current', 'latest-estimation'];
